/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Notfound_Subtext_No_SetInputs */



/**
* | output |
* | --- |
* | "This page isn't in any set we know of." |
*
* @param {Error_Notfound_Subtext_No_SetInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_notfound_subtext_no_set = /** @type {((inputs?: Error_Notfound_Subtext_No_SetInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Notfound_Subtext_No_SetInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Seite ist in keinem Set, das wir kennen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette page n'est dans aucune extension que nous connaissons.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("这个页面不属于我们已知的任何系列。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("這個頁面不屬於我們知道的任何套組。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("이 페이지는 저희가 아는 어떤 세트에도 없습니다.")
	return /** @type {LocalizedString} */ ("This page isn't in any set we know of.")
});